import React, { createContext, useContext } from "react";
export const defaultSpacing = (size) => size * 4;
export const SpacingContext = createContext(defaultSpacing);
export const useSpacing = () => useContext(SpacingContext);
export const SpacingProvider = ({ spacing = defaultSpacing, children }) => {
    return <SpacingContext.Provider value={spacing}>{children}</SpacingContext.Provider>;
};
